import React from 'react'
import Grid from '@material-ui/core/Grid'
import User from 'EurestoClass/User'
import Draggable from 'react-draggable'
import Data from 'EurestoClass/Data'
import Constants from 'EurestoFonction/Constants'
import Table from './Table'
import Tooltip from 'Components/Tooltip'
import Modal from 'Components/Modal'

import List from '@material-ui/core/List'
import ListItem from '@material-ui/core/ListItem'
import EurestoDiv from 'EurestoComponents/EurestoDiv'
import Input from 'Components/Input'
import Utils from 'EurestoFonction/Utils'
import {ClickAwayListener} from '@material-ui/core'

export default class extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      action: 'move',
      key: Utils.getRandomNumber(),
      regroupement: {
        tables: [],
        categorie_id: undefined
      },
      anchorEl: {},
      tablePosition: props.tables || [],
      tables: Data.list(Constants.module.RESTAURANT, Constants.donnee.table),
    }
    Data.addCbRestate(Constants.module.RESTAURANT, Constants.donnee.table, this.restate)
  }

  restate = () => {
    this.setState({
      datas: Data.list(Constants.module.RESTAURANT, Constants.donnee.table)
    })
  }

  onDrop = (index) => (e, position) => {
    const { tablePosition } = this.state
    tablePosition[index] = {
      ...tablePosition[index],
      x: position.x,
      y: position.y
    }
    this.setState({
      tablePosition: tablePosition
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }

  showOption = e => {
    e.preventDefault()
  }

  handleCloseElAction = (event, id) => {
    this.setState({
      anchorEl: {
        ...this.state.anchorEl || {},
        [id]: null
      }
    })
  }

  handleClickElAction = (id) => (e) => {
    e.preventDefault()
    if (e.target.className.indexOf('anchorElement') !== -1) {
      this.setState({
        anchorEl: {
          ...this.state.anchorEl || {},
          [id]: e.target
        }
      })
    }
  }

  startRegroupementTable = (index) => _ => {
    const { tablePosition } = this.state
    const table = tablePosition[index]
    this.setState({
      anchorEl: {
        ...this.state.anchorEl || {},
        [table.id]: null
      },
      action: 'regroupement',
      regroupement: {
        tables: [index],
        categorie_id: table.categorie_id
      }
    })
  }

  addRegroupementTable = (index) => _ => {
    const { regroupement } = this.state
    const i = regroupement.tables.indexOf(index)
    if (i === -1) {
      regroupement.tables.push(index)
    } else {
      regroupement.tables.splice(i, 1)
    }
    this.setState({
      regroupement: regroupement
    })
  }

  endRegroupementTable = _ => {
    const { regroupement, tablePosition } = this.state
    if (regroupement.tables.length > 1) {
      const MainTable = tablePosition[regroupement.tables[0]]
      regroupement.tables.map((tableIndex, i) => {
        if (i !== 0) {
          tablePosition[tableIndex].groupe_id = MainTable.id
          tablePosition[tableIndex].verticale = MainTable.verticale
        }
      })
    }
    this.setState({
      action: 'move',
      regroupement: {
        tables: [],
        categorie_id: undefined
      },
      tablePosition: tablePosition
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }

  cancelRegroupementTable = _ => {
    this.setState({
      action: 'move',
      regroupement: {
        tables: [],
        categorie_id: undefined
      },
      anchorEl: {},
    })
  }

  removeTable = (i) => _ => {
    const { tablePosition } = this.state
    const table = tablePosition.splice(i, 1)
    this.setState({
      anchorEl: {
        ...this.state.anchorEl || {},
        [table.id]: null
      },
      tablePosition: tablePosition
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }

  setvertical = i => _ => {
    const { tablePosition } = this.state
    tablePosition[i].verticale = !tablePosition[i].verticale && 1 || 0
    this.setState({
      tablePosition: tablePosition,
      anchorEl: {
        ...this.state.anchorEl || {},
        [tablePosition[i].id]: null,
      },
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }

  dissocier = i => _ => {
    const { tablePosition } = this.state
    const table = tablePosition[i]
    tablePosition.map((t, index) => {
      if (t.groupe_id === table.id) {
        tablePosition[index].groupe_id = undefined
      }
    })
    this.setState({
      anchorEl: {
        ...this.state.anchorEl || {},
        [table.id]: null
      },
      tablePosition: tablePosition
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }

  handleShowModalTableConfiguration = i => view => _ => {
    this.setState({
      configuration_index: i,
      showModalTableConfiguration: view,
      configuration: {}
    })
  }

//testssss
  render () {
    return (
      <Grid key={this.state.key} container style={{ margin: 0, padding: 0 }} spacing={0} direction="column"
            justify="center"
            alignItems="stretch">
        <Grid container spacing={0} style={{
          margin: 1,
          position: 'relative',
          border: '1px solid grey',
          marginBottom: 5,
          padding: '0px 5px',
          width: this.props.width && (this.props.width + 'px') || 'auto',
          height: this.props.height && (this.props.height + 'px') || User.CalculHeight.getHeightWanted(275),
          maxHeight: User.CalculHeight.getHeightWanted(275),
          maxWidth: '100%',
          borderRadius: 2.5
        }}>
          {
            this.state.tablePosition.filter(table => !table.groupe_id).map(table => {
              const i = this.state.tablePosition.findIndex(t => t.id === table.id)
              const isGroup = this.state.tablePosition.findIndex(t => t.groupe_id === table.id) !== -1
              const categorie = Data.get(Constants.module.RESTAURANT, Constants.donnee.table_categorie, { id: table.categorie_id })
              const tablesInGroup = isGroup && this.state.tablePosition.filter(subTable => subTable.groupe_id === table.id) || []
              const couvertTablesInGroup = isGroup && tablesInGroup.reduce((x, y) => x + y.couverts_max, 0)
              return (<Draggable
                axis={'both'}
                disabled={(this.props.disabled || this.state.action !== 'move')}
                onStop={this.onDrop(i)}
                bounds="parent"
                defaultPosition={{ x: 0, y: 0 }}
                position={{
                  x: table.x,
                  y: table.y
                }}>
                <div
                  style={{ position: 'absolute' }}
                  onClick={
                    this.state.action === 'regroupement' && table.categorie_id === this.state.regroupement.categorie_id && this.addRegroupementTable(i)
                  }
                >
                  <Tooltip
                    open={Boolean(this.state.anchorEl[table.id]) || false}
                    PopperProps={{
                      disablePortal: true,
                    }}
                    key={Boolean(this.state.anchorEl[table.id])+'-tooltip-'+table.id}
                    interactive
                    margin={'dense'}
                    disableFocusListener
                    disableHoverListener
                    disableTouchListener
                    title={
                      <ClickAwayListener onClickAway={(event) => this.handleCloseElAction(event, table.id)}>
                      <Grid item style={{ margin: 0, padding: 0, fontSize: 15, backgroundColor: 'white', zIndex: 100 }}>
                        <List component="nav" dense>
                          {this.state.action !== 'regroupement' && <React.Fragment>
                            {!isGroup && categorie.forme === 1 &&
                            <ListItem onClick={this.startRegroupementTable(i)} button component={'li'}><i
                              className={'ei-commun_modifier'}/>
                              &nbsp;Regrouper
                            </ListItem>}
                            {categorie.forme === 1 &&
                            <ListItem onClick={this.setvertical(i)} button component={'li'}><i
                              className={'fa fa-undo'}/>
                              &nbsp;{`${!table.verticale && 'Placer à la vertical' || 'Placer à l\'horizontal'}`}
                            </ListItem>}
                            {isGroup && <ListItem onClick={this.dissocier(i)} button component={'li'}>
                              <i className={'ei-commun_fermer'}/>&nbsp;Dissocier
                            </ListItem>}
                            {!isGroup && <ListItem onClick={this.removeTable(i)} button component={'li'}>
                              <i className={'ei-commun_supprimer'}/>&nbsp;Supprimer
                            </ListItem>}
                            <ListItem onClick={this.handleShowModalTableConfiguration(i)(true)} button
                                      component={'li'}>
                              <i className={'ei-commun_configuration'}/>&nbsp;Configurer
                            </ListItem>
                          </React.Fragment>
                          ||
                          <React.Fragment>
                            <ListItem onClick={this.endRegroupementTable} button component={'li'}>
                              <i className={'fa fa-save'}/>&nbsp;Sauvegarder
                            </ListItem>
                            <ListItem onClick={this.cancelRegroupementTable} button component={'li'}>
                              <i className={'ei-commun_fermer'}/>&nbsp;Annuler
                            </ListItem>
                          </React.Fragment>
                          }
                        </List>
                      </Grid>
                      </ClickAwayListener>
                    }>
                      <Table
                        action={this.state.action}
                        groupe={this.state.regroupement}
                        selected={this.state.action === 'regroupement' && this.state.regroupement.tables.indexOf(i) !== -1}
                        table={{
                          ...table,
                          forme: categorie.forme,
                          libelle: isGroup ? `(${table.libelle + ', ' + (tablesInGroup.map(t => t.libelle).join(', '))})` : table.libelle,
                          couverts_max: isGroup ? table.couverts_max + couvertTablesInGroup : table.couverts_max,
                          couverts_min: isGroup ? table.couverts_group_min || (table.couverts_max + couvertTablesInGroup) : table.couverts_min,
                          groupe_id: isGroup ? table.id : undefined
                        }}
                        disabled={this.props.disabled}
                        onContextMenu={(this.state.action !== 'regroupement' || (this.state.action === 'regroupement' && this.state.regroupement.tables.indexOf(i) !== -1)) && this.handleClickElAction(table.id)}/>
                  </Tooltip>
                </div>
              </Draggable>)
            })
          }
        </Grid>
        {
          this.state.tables.filter(table => this.state.tablePosition.findIndex(tp => tp.id === table.id) === -1).length > 0 &&
          <Grid container wrap={'nowrap'} spacing={0} alignContent={'center'} justify={'flex-start'}
                alignItems={'center'}
                style={{
                  margin: 0,
                  position: 'relative',
                  border: '1px solid grey',
                  marginBottom: 5,
                  padding: 5,
                  height: 100,
                  borderRadius: 2.5,
                  overflowX: 'auto',
                }}>
            {
              this.state.tables.filter(table => this.state.tablePosition.findIndex(tp => tp.id === table.id) === -1).map(table => {
                const categorie = Data.get(Constants.module.RESTAURANT, Constants.donnee.table_categorie, { id: table.categorie_id })
                return <div onDoubleClick={_ => !this.props.disabled && this.addTable(table)}
                            style={{ margin: 2.5, position: 'relative' }}>
                  <Table className={'cursor-pointer'} table={{
                    ...table,
                    forme: categorie.forme
                  }} disabled={this.props.disabled}/>
                </div>
              })
            }
          </Grid>
        }
        <Modal open={this.state.handleShowModalTableConfiguration}>
          {this.configurationTableForm(this.state.configuration_index)}
        </Modal>
      </Grid>
    )
  }

  configurationTableForm = (i) => _ => {
    return <EurestoDiv
      fromModal={true} style={{
      margin: 0,
      padding: 0,
      overflowY: 'auto'
    }} title={EurestoI18n.t('commun:Confirmation de fermeture du dossier')}
      buttonsLeft={[{
        icon: ' ei-commun_fermer',
        className: 'EurestoError--text EurestoText',
        cb: _ => this.handleShowModalTableConfiguration(undefined)(false)
      }]}
      buttonsRight={[{
        icon: ' ei-commun_valider',
        className: 'text-success',
        cb: () => this.saveConfiguration(i) || this.handleShowModalTableConfiguration(undefined)(false)
      }]}>
      <Grid container style={{ margin: 0, padding: 10 }} spacing={0} justify={'center'} alignItems={'stretch'}>
        <Input
          title={EurestoI18n.t('commun:Nom')}
          disabled={disabled}
          onChange={this.onChangeConfiguration}
          name={'libelle'}
          value={this.state.libelle !== undefined ? this.state.libelle : ''}
          type={'text'}
        />
        <Input
          title={EurestoI18n.t('commun:Nom')}
          disabled={disabled}
          onChange={this.onChangeConfiguration}
          name={'libelle'}
          value={this.state.libelle !== undefined ? this.state.libelle : ''}
          type={'text'}
        />
      </Grid>
    </EurestoDiv>
  }

  saveConfiguration = i => {
    const { configuration, tablePosition } = this.state
    tablePosition[i] = {
      ...tablePosition[i],
      ...configuration
    }
    this.setState({
      configuration: {},
      tablePosition: tablePosition
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }

  onChangeConfiguration = (data, name) => {
    const { configuration } = this.state
    configuration[name] = data
    this.setState({
      configuration: configuration
    })
  }

  addTable = table => {
    let { tablePosition } = this.state
    tablePosition = [
      ...tablePosition,
      {
        ...table,
        x: 0,
        y: 0
      }
    ]
    this.setState({
      tablePosition: tablePosition
    }, _ => this.props.onChange && this.props.onChange(tablePosition, this.props.name))
  }
}



// WEBPACK FOOTER //
// ./app/Utilitaire/Component/Carcasse/index.js